import React from "react";
import MainApp from "./components/MainApp";
import Login from "./components/application/login/Login";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import { AuthProvider, useAuth } from "./components/utils/AuthContext";

function AuthGate() {
    const { isAuthenticated } = useAuth();
    return isAuthenticated ? <MainApp /> : <Login />;
}

export default function App() {
    return (
        <ThemeProvider theme={theme}>
            <AuthProvider>
                <AuthGate />
            </AuthProvider>
        </ThemeProvider>
    );
}